module.exports = __webpack_public_path__ + "img/croatia.63b2b01d.svg";